import { render, staticRenderFns } from "./MultipleCheckboxesInput.vue?vue&type=template&id=12063140&"
import script from "./MultipleCheckboxesInput.vue?vue&type=script&lang=js&"
export * from "./MultipleCheckboxesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports